export default "__VITE_ASSET__CRV$gqVV__"